import { DateTimeEditor, DropdownEditor, Field, TextEditor } from '@approvalmax/ui';
import { dataProviders } from 'modules/common';
import { domain } from 'modules/data';
import { memo } from 'react';

import { PLACEHOLDER_FIELD } from '../../RequestSearchPopup.constants';
import { DateFieldRow, DateRow, WrapFieldRow } from '../../RequestSearchPopup.styles';
import { messages } from './DearSearchFields.messages';
import { DearSearchFieldsProps } from './DearSearchFields.types';

export const DearSearchFields = memo<DearSearchFieldsProps>((props) => {
    const { integrationEnabled, params, updateParameter, integrationCode, disabled } = props;

    return (
        <>
            <WrapFieldRow>
                <Field title={messages.dearSectionOrderNumber}>
                    <TextEditor
                        placeholder={messages.dearSectionOrderNumberPlaceholder}
                        value={params.dearOrderNumber}
                        onChange={updateParameter('dearOrderNumber')}
                        disabled={disabled}
                    />
                </Field>

                <Field title={messages.dearSectionLocation}>
                    <dataProviders.FieldDataProvider
                        integrationCode={integrationCode}
                        field={
                            params.company?.fields.find(
                                (field) => field.systemPurpose === domain.FieldSystemPurpose.DearLocation
                            ) || PLACEHOLDER_FIELD
                        }
                    >
                        <DropdownEditor
                            placeholder={messages.dearSectionLocationPlaceholder}
                            disabled={disabled || !integrationEnabled}
                            value={params.dearLocation}
                            onChange={updateParameter('dearLocation')}
                        />
                    </dataProviders.FieldDataProvider>
                </Field>

                <Field title={messages.dearSectionSupplier}>
                    <dataProviders.FieldDataProvider
                        integrationCode={integrationCode}
                        field={
                            params.company?.fields.find(
                                (f) => f.systemPurpose === domain.FieldSystemPurpose.DearSupplier
                            ) || PLACEHOLDER_FIELD
                        }
                    >
                        <DropdownEditor
                            placeholder={messages.dearSectionSupplierPlaceholder}
                            disabled={disabled || !integrationEnabled}
                            value={params.dearSuplier}
                            onChange={updateParameter('dearSuplier')}
                        />
                    </dataProviders.FieldDataProvider>
                </Field>

                <Field title={messages.dearSectionProduct}>
                    <dataProviders.FieldDataProvider
                        integrationCode={integrationCode}
                        field={
                            params.company?.fields.find(
                                (f) => f.systemPurpose === domain.FieldSystemPurpose.DearProduct
                            ) || PLACEHOLDER_FIELD
                        }
                    >
                        <DropdownEditor
                            placeholder={messages.dearSectionProductPlaceholder}
                            disabled={disabled || !integrationEnabled}
                            value={params.dearProduct}
                            onChange={updateParameter('dearProduct')}
                        />
                    </dataProviders.FieldDataProvider>
                </Field>

                <Field title={messages.dearSectionAccount}>
                    <dataProviders.FieldDataProvider
                        integrationCode={integrationCode}
                        field={
                            params.company?.fields.find(
                                (f) => f.systemPurpose === domain.FieldSystemPurpose.DearAccount
                            ) || PLACEHOLDER_FIELD
                        }
                    >
                        <DropdownEditor
                            placeholder={messages.dearSectionAccountPlaceholder}
                            disabled={disabled || !integrationEnabled}
                            value={params.dearInventoryAccount}
                            onChange={updateParameter('dearInventoryAccount')}
                        />
                    </dataProviders.FieldDataProvider>
                </Field>
            </WrapFieldRow>

            <DateRow>
                <Field title={messages.dearSectionOrderDate}>
                    <DateFieldRow>
                        <div>{messages.dateFromLabel}</div>

                        <DateTimeEditor
                            placeholder={messages.dateGreaterEqualsPlaceholder}
                            value={params.dearOrderDateGreaterEquals}
                            onChange={updateParameter('dearOrderDateGreaterEquals')}
                            disabled={disabled}
                        />

                        <div>{messages.dateToLabel}</div>

                        <DateTimeEditor
                            placeholder={messages.dateLessEqualsPlaceholder}
                            value={params.dearOrderDateLessEquals}
                            onChange={updateParameter('dearOrderDateLessEquals')}
                            disabled={disabled}
                        />
                    </DateFieldRow>
                </Field>
            </DateRow>

            <DateRow>
                <Field title={messages.dearSectionRequiredBy}>
                    <DateFieldRow>
                        <div>{messages.dateFromLabel}</div>

                        <DateTimeEditor
                            placeholder={messages.dateGreaterEqualsPlaceholder}
                            value={params.dearRequiredByGreaterEquals}
                            onChange={updateParameter('dearRequiredByGreaterEquals')}
                            disabled={disabled}
                        />

                        <div>{messages.dateToLabel}</div>

                        <DateTimeEditor
                            placeholder={messages.dateLessEqualsPlaceholder}
                            value={params.dearRequiredByLessEquals}
                            onChange={updateParameter('dearRequiredByLessEquals')}
                            disabled={disabled}
                        />
                    </DateFieldRow>
                </Field>
            </DateRow>

            <br />
        </>
    );
});

DearSearchFields.displayName = 'DearSearchFields';
